import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import './style.sass';
import { useForm } from "react-hook-form";
import HeaderMobileCredito from 'components/Header/HeaderMobileCredito';
import ModalPortal from 'components/Modal';
import { ModalTarjetaExpress } from '../7-Modals';
import { Header } from 'pages/Header'
import { Footer } from 'pages/Footer';
import { MenuCredito } from 'components/menuCredito';
import { InputTypeAndroid } from 'components/Forms/InputType';
import EstatusActualDeSolicitud from './estatusActualSolicitud';
import { ModalError } from 'components/Error/ErrorModal';
import { useIsMobile } from 'hooks/useIsMobile';
import getStatusSolicitud from 'services/getStatusSolicitud';
import Loading from 'components/Loading'
import { Error500 } from 'components/Error/Error500'

export default function ConsultarEstatusSolicitud() {

    const history = useHistory();
    const { isMobile } = useIsMobile();
    const [ loading, setLoading ] = useState(true)

    //- Codigo de instana para track de pagina 
    useEffect(()=>{
        // window.ineum('page', 'Add Card  Credit-Page')
        // window.ineum('meta', 'portal', 'Credito')
        setLoading(false)
    },[])

    const [showModalFolioInvalido, SetShowModalFolioInvalido] = useState(false);
    const [datosFolio,] = useState(false);
    const { register, handleSubmit, errors, clearErrors, reset } = useForm({
        defaultValues: {
            folio: datosFolio.folio,
        }
    });
    const [datos, setDatos] = useState();
    const [returnForm, SetReturnForm] = useState(false);
    const [response, setResponse] = useState();

    const [errorCode, setErrorCode] = useState();
    const [messageResponse, setMessageResponse] = useState();
    const [inputFolio, setInputFolio] = useState();
    const [sectionActive, setSectionActive] = useState(null);
    const [showModalErr, setShowModalErr] = useState(false);

    //- valores para agregar folio
    const [inputNumberFolio, setInputNumberFolio] = useState();

    // ocultar modal
    const noRemove = () => {
        SetShowModalFolioInvalido(false);
    };

    // ocultar modal
    const siRemove = () => {
        SetShowModalFolioInvalido(false);
    };

    // cerrar modal de folio Invalida
    const handleClose = () => SetShowModalFolioInvalido(false);

    // guarda la informacion enviada en el formulario
    const sendFormInformacionFolio = data => {
        setDatos({
            "folio": data.folio
        });
        SetReturnForm(true);
    };

    // al recibir data del formulario se guarda en variable datos folio
    useEffect(() => {
        if (returnForm) {
            // console.log('datos: ',datos.folio)
            setLoading(true)
            getStatusSolicitud(datos.folio)
            .then(setResponse)
        }
    }, [returnForm]);

    const [estatusActual, setEstatusActual] = useState(false);
    const [mostrarConsultar, setMostrarConsultar] = useState(true);

    const [err500, setErr500] = useState()
    useEffect(() => {
        if (response) {
            if (response.statusCode === 200) {
                if (response?.data) {
                    setEstatusActual(response?.data?.estatus);
                    // console.log('response?.data[0]?.estatus: ', response?.data?.estatus)
                    setMostrarConsultar(false)
                    setLoading(false)
                }
            }
            else if (response.statusCode >= 400 && response.statusCode <= 499) {
                setLoading(false)
                if (response?.data) {
                    setShowModalErr(true);
                    setErrorCode(response?.statusCode);
                    setMessageResponse(response?.data?.error?.message)
                }
            }
            else if (response.statusCode >= 500) {
                setLoading(false)
                setErr500(response.statusCode)
            }
            else {
                setInputNumberFolio('');
                SetReturnForm(false);
                SetShowModalFolioInvalido(true)
                setLoading(false)
            }
        }
    }, [response])

    // validaciones
    const valFolio = {
        required: 'Campo obligatorio',
        minLength: {
            value: 7,
            message: 'Faltan dígitos. Deben ser 7 dígitos'
        },
        maxLength: {
            value: 16,
            message: 'No debe contener más de 16 dígitos'
        },
        pattern: {
            value: /[0-9]{7,16}/,
            message: 'El formato del folio es inválido'
        }
    }

    const resetErrors = (value) =>{
        let inputId = document.querySelector(`#${value} ~ .error`)
        if(inputId){
            let valu = value
            clearErrors(valu)
            reset({valu},{
                keepErrors: false, 
                keepDirty: true,
                keepIsSubmitted: false,
                keepTouched: false,
                keepIsValid: false,
                keepSubmitCount: false,
            });
        }
    }

    useEffect(() => {
        setMostrarConsultar(true);
    }, [])

    // valida creacion de ticket y si no pasa manda el error
    const handleCloseErr = () => {
        setShowModalErr(false);
        //history.replace(`${BASE_PATH}${SUB_DIRECTORY}`);
    }

    return (
        <>
            { loading && <Loading /> }
            {isMobile
                ? isMobile === 'desktop'
                    ? <Header type="complete" />
                    : <HeaderMobileCredito title={"Pago express"} type="backFull" btnTypeR="floatMenu" />
                : null
            }

            <div className={isMobile === 'desktop' ? "container" : null}>
                <div className="contPlanPayments">
                    <MenuCredito />
                    {err500 >= 500
                            ? <Error500 />
                            :
                                <div className="contPlanes">
                                    <div className="contenedorGeneral">
                                        {mostrarConsultar === true
                                            ? <div className="boxExpress">
                                                <div className="boxCopyConsultar">
                                                    <p>Ingresa el número de folio que recibiste al realizar la solicitud de crédito.</p>
                                                </div>

                                                <div className="boxFormConsultar">
                                                    <form onSubmit={handleSubmit(sendFormInformacionFolio)} className="formConsultar form-js-label">
                                                        <InputTypeAndroid
                                                            type="text"
                                                            name="folio"
                                                            id="folio"
                                                            placeholder="Folio"
                                                            refs={register(valFolio)}
                                                            autocomplete='folio'
                                                            setNumero={setInputFolio}
                                                            value={inputFolio}
                                                            errorMessage={errors.folio && errors.folio.message}
                                                            pattern={'number'}
                                                            minLength={7}
                                                            maxLength={16}
                                                            click={() => resetErrors('numero')}
                                                        />

                                                        <div className="boxBtnConsultar">
                                                            <button className="btnConsultar">Consultar</button>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                            : <div className="boxExpress">
                                                <EstatusActualDeSolicitud estatus={estatusActual} />
                                            </div>
                                        }
                                    </div>
                                </div>
                    }
                </div>
            </div>

            {isMobile
                ? isMobile === 'desktop'
                    ? <Footer type="complete" />
                    : null
                : null
            }

            {showModalFolioInvalido &&
                <ModalPortal type="modalSB" onClose={handleClose} >
                    <ModalTarjetaExpress remvoeAction={siRemove} awaitAction={noRemove}
                        body="Lo sentimos, el número de folio que ingresaste no es válido." />
                </ModalPortal>
            }

            {showModalErr &&
                <ModalError
                    errorCode={errorCode}
                    handleClose={handleCloseErr}
                    message={messageResponse}
                />
            }
        </>
    )
}